var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62649 7.83161L0.181382 1.12101C0.0578051 0.991073 -0.00676928 0.823936 0.000563564 0.652994C0.00789641 0.482053 0.0865961 0.319899 0.220936 0.198936C0.355275 0.0779719 0.535361 0.0071079 0.725204 0.000505205C0.915048 -0.00609749 1.10067 0.0520474 1.24497 0.16332L8.07908 6.31697L14.7171 0.339916C14.8584 0.213413 15.0496 0.142406 15.2489 0.142406C15.4481 0.142406 15.6393 0.213413 15.7807 0.339916C15.9211 0.467175 16 0.639322 16 0.81876C16 0.998198 15.9211 1.17034 15.7807 1.2976L8.53167 7.83161C8.41149 7.93945 8.24874 8 8.07908 8C7.90941 8 7.74667 7.93945 7.62649 7.83161Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdownArrow.54348adcb726ca3fa003be73199add9a.svg";
export { ForwardRef as ReactComponent };